import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getDetail = async (params: object) => {
  return await GET({
    url: Api.detail,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier'
    }
  })
}
